<template>
	<div
		:class="rootPage.branding"
	>
		<programm-header
			v-if="rootPage.typology === TYPOLOGY.PROGRAM"
			ref="program-header"
			:fetched-data="rootPage"
			:links="links"
			:event-page="true"
		/>
		<event-header v-else :fetched-data="rootPage" />
		<alumni-header v-if="check" :event-page="eventPage" />

		<div v-if="isAlumni || !notAlumniPage">
			<div v-for="(block, index) in filteredBlocks" :key="index">
				<component
					:is="block.type"
					v-if="!block.on_broadcast_page"
					:ref="block.type"
					:index="index"
					:block="block"
					:content="block.content"
					:fetched-data="rootPage"
					:static_content="block.static_content"
					:block_title="block.block_title"
				/>
			</div>
		</div>

		<input id="landingId" type="hidden" :value="rootPage.landing_id">
		<input id="eventId" type="hidden" :value="rootPage.id">
		<input
			v-if="rootPage.issue !==null"
			id="okUrl"
			type="hidden"
			:value="'/' + rootPage.typology_slug + '/' + rootPage.slug + '/ok-success/'"
		>

		<main-footer-eng v-if="$i18n.locale ==='en'" :fetched-data="rootPage" />
		<main-footer v-else :fetched-data="rootPage" />
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import panels from '~/mixins/panels';
import { TYPOLOGY } from '~/utils/dictionaries';

import RegistrationCounterImage from '~/components/refactor/RegistrationCounterImage.vue';

import GraduateReviews from '~/components/refactor/GraduateReviews.vue';
import Presentations from '~/components/refactor/Presentations.vue';

import EventHeader from '~/components/layouts/headers/EventHeader.vue';
import ProgrammHeader from '~/components/layouts/headers/ProgrammHeader.vue';
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import MainFooterEng from '~/components/layouts/footers/MainFooterEng.vue';

import HtmlWithBackground from '~/components/refactor/HtmlWithBackground.vue';
import HtmlRaw from '~/components/refactor/HtmlRaw.vue';
import AlumniHeader from '~/components/alumniHeader.vue';
import makeCanonicalLink from '~/utils/seo/makeCanonicalLink';

export default {
	components: {
		AlumniHeader,
		HtmlWithBackground, // удалить после переноса
		HtmlRaw, // удалить после переноса

		EventHeader,
		MainFooter,
		MainFooterEng,
		ProgrammHeader,

		GraduateReviews,
		Presentations,
		RegistrationCounterImage,
	},
	mixins: [panels],
	data() {
		return {
			eventPage: null,
			TYPOLOGY,
		};
	},
	provide() {
		return {
			fetchedDataEventPage: this.eventPage
		};
	},
	async asyncData({
		app, params, query, store, route, redirect,
	}) {
		const { $pagesApi, i18n, $api } = app;
		const { eventSlug, innerPageSlug } = params;
		const { uuid } = query;
		const [eventPage] = await Promise.all([
			$pagesApi.eventPage(eventSlug, innerPageSlug)
		]);
		const { event } = eventPage;

		let application = {};

		if (uuid) {
			application = await $api.getApplicationData(uuid);
		}

		if (!eventPage) return {};

		const baseRoute = route.path.split('/').splice(2).join('/');
		if (route.name === 'programmes-detail' && event.typology === 0) {
			return redirect(`/events/${baseRoute}`);
		} if (route.name === 'events-inner-page' && event.typology === 1) {
			return redirect(`/programmes/${baseRoute}`);
		}

		return { eventPage, application };
	},
	head() {
		return {
			title: this.metaTags.title,
			link: [
				{
					rel: 'canonical',
					hid: 'canonical',
					href: makeCanonicalLink(this.$route.path),
				},
			],
			meta: [
				{
					name: 'description',
					hid: 'description',
					content: this.metaTags.description,
				},
				{
					hid: 'robots',
					name: 'robots',
					content: this.eventPage.meta_indexing,
				},
				// Open Graph
				{
					name: 'og:title',
					hid: 'og:title',
					content: this.metaTags.title,
				},
				{
					name: 'og:description',
					hid: 'og:description',
					content: this.metaTags.description,
				},
				{
					name: 'og:type',
					hid: 'og:type',
					content: 'article',
				},
				{
					name: 'og:image',
					hid: 'og:image',
					content: this.metaTags.image,

				},
				// Twitter Card
				{
					name: 'twitter:card',
					content: 'summary',
				},
				{
					name: 'twitter:site',
					content: '@nuxt_js',
				},
				{
					name: 'twitter:title',
					content: this.metaTags.title,
				},
				{
					name: 'twitter:description',
					content: this.metaTags.description,
				},
				{
					name: 'twitter:image',
					content: this.metaTags.image,
				},

				{
					name: 'image',
					property: 'og:image',
					content: this.metaTags.image,
				},
				{
					name: 'author',
					content: 'SKOLKOVO',
				},
			],
		};
	},
	computed: {
		rootPage() {
			return this.eventPage.event;
		},
		links() {
			const { event_pages: pages, slug, title } = this.eventPage.event;
			if (!Array.isArray(pages) || pages.length === 0) return false;
			const links = pages.map(({ slug: path, title: name, active }) => ({ path: `/programmes/${slug}/${path}/`, name, active }));
			links.unshift({ path: `/programmes/${slug}/`, title, home: true });

			return links;
		},
		metaTags() {
			const title = this.eventPage.meta_title || `${this.eventPage.title} - ${this.rootPage.meta_title}`;
			const image = this.rootPage.smm_image_default.src
				|| this.rootPage.top_cover_image_url_default;
			const description = this.eventPage.meta_description || this.eventPage.description
				|| `${title}. ${this.rootPage.meta_description || this.rootPage.description}`;

			return { title, description, image };
		},
		check() {
			return (!this.$auth.user && this.$store.state.alumni.eventInnerPage)
				|| (!this.isAlumni && this.eventPage.is_alumni);
		},
		isAlumni() {
			return this.$store.getters['profile/isAlumni'];
		},
		notAlumniPage() {
			return this.$store.state.alumni.eventInnerPage;
		},
		filteredBlocks() {
			return this.eventPage.blocks.filter((block) => block.is_alumni_block !== 4);
		},
	},
	created() {
		this.checkValue();
		if (this.$store.state.alumni.eventInnerPage && !this.$auth.loggedIn) {
			this.showLoginPopup();
		}
	},
	mounted() {
		if (this.eventPage.event) {
			if (this.eventPage.event.taxonomy.project && this.eventPage.event.taxonomy.project.chat_id) {
				this.loadJivo(this.eventPage.event.taxonomy.project.chat_id);
			} else {
				this.loadJivo();
			}
		}
	},
	methods: {
		...mapActions({
			loadJivo: 'scripts/loadJivo',
			showLoginPopup: 'authModal/showLogin',
		}),
		...mapMutations({
			checkAlumni: 'alumni/eventInnerPage',
		}),
		checkValue() {
			if (this.eventPage.is_alumni === true) {
				this.checkAlumni(true);
			}
		},
	},
};
</script>
